import { useCallback, useRef, useEffect } from 'react';

import { EMAIL, REMINDER } from '../../../utils/constants';

const messagePreviewUrl = (
  postId,
  audienceId,
  isFollowupEmail,
  messageTemplate,
) => {
  return `/client_admin/campaigns/message_preview/${EMAIL.toLowerCase()}?post_id=${postId}&audience_id=${audienceId}&follow_up_email=${isFollowupEmail}&template=${messageTemplate}`;
};

export const usePreviewIframe = ({ form, tab }) => {
  const iframeRef = useRef(null);
  const isFollowupEmail = tab === REMINDER;

  const emailTemplate = isFollowupEmail
    ? form.values.reminderTemplate
    : form.values.messageTemplate;

  const tilesTemplate = emailTemplate === 'with_tiles';

  const updateIframe = useCallback(() => {
    const headlinePreview = iframeRef.current.contentDocument.querySelector(
      '#custom_headline',
    );
    const messagePreview = iframeRef.current.contentDocument.querySelector(
      '#custom_message p',
    );

    const messageCta = iframeRef.current.contentDocument.querySelector(
      '#cta_message',
    );

    const messageFooter = iframeRef.current.contentDocument.querySelector(
      '#message_footer',
    );

    if (headlinePreview) {
      headlinePreview.textContent = tilesTemplate ? form.values.headline : '';
    }
    if (messagePreview) {
      if (isFollowupEmail) {
        messagePreview.textContent = tilesTemplate
          ? form.values.message
          : form.values.reminderBody;
      } else {
        messagePreview.textContent = form.values.message;
      }
    }
    if (messageCta) {
      messageCta.textContent = isFollowupEmail
        ? form.values.reminderCta
        : form.values.messageCta;
    }
    if (messageFooter) {
      messageFooter.textContent = isFollowupEmail
        ? form.values.reminderFooter
        : form.values.messageFooter;
    }
  }, [
    isFollowupEmail,
    tilesTemplate,
    form.values.headline,
    form.values.message,
    form.values.reminderBody,
    form.values.messageCta,
    form.values.reminderCta,
    form.values.messageFooter,
    form.values.reminderFooter,
  ]);

  useEffect(() => {
    if (iframeRef.current) {
      updateIframe();
    }
  }, [form.values, updateIframe]);

  return {
    updateIframe,
    iframeRef,
    iframeSrc: messagePreviewUrl(
      form.values.postId,
      form.values.audienceId,
      isFollowupEmail,
      emailTemplate,
    ),
  };
};

export default usePreviewIframe;
